/**
 * The frame for the signed-out pages that are not the sign-in form itself —
 * forgot password, reset password, accept invitation (FS-012).
 *
 * The sign-in page's right-hand panel without the marketing half: someone
 * resetting a password is mid-task, and a hero image is in the way.
 */

import type { ReactNode } from "react";

interface AuthShellProps {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}

function AuthShell({ title, subtitle, children, footer }: AuthShellProps) {
  return (
    <div
      className="flex min-h-screen items-center justify-center px-6 py-12"
      style={{
        background: `linear-gradient(135deg, var(--color-bg-gradient-from), var(--color-bg-gradient-via), var(--color-bg-gradient-to))`,
      }}
    >
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center gap-2.5">
          <img
            src="/logo.png"
            alt=""
            className="h-8 w-8 rounded-[var(--radius-lg)]"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
          <span className="text-sm font-semibold tracking-tight text-[var(--text-secondary)]">
            TradeRoute
          </span>
        </div>
        <h1 className="text-2xl font-bold tracking-tight text-[var(--text-primary)]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-1.5 text-sm leading-relaxed text-[var(--text-secondary)]">
            {subtitle}
          </p>
        )}
        <div className="mt-6 rounded-[var(--radius-2xl)] glass glass-glow p-7 animate-fade-in">
          {children}
        </div>
        {footer && (
          <p className="mt-5 text-center text-sm text-[var(--text-secondary)]">
            {footer}
          </p>
        )}
      </div>
    </div>
  );
}

export default AuthShell;
